export class Country{
    id?: number;
    code?: string;
    name?: string;
    nameEnglish?: string;
    domainCode?: string;
    phoneCode?: number;
    parentId?:number;
}
